"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Time {
    static fromStrings(hour, minute, second) {
        return {
            hour: parseInt(hour, 10),
            minute: parseInt(minute, 10),
            second: !second ? null : parseInt(second, 10),
        };
    }
    static parse(s) {
        const [hour, minute, second] = s.split(':');
        return this.fromStrings(hour, minute, second);
    }
}
exports.default = Time;
//# sourceMappingURL=Time.js.map